import React, { FC } from "react";
import { useTheme, withThemeProvider } from "@narvar/nth-hook-theme";
import { useStyles } from "./SelectListStyles";
import { ListProps, SelectListOption } from "./types";
import StyledMarkup from "../StyledMarkup";
import SelectItem from "../SelectItem/SelectItem";

const SelectListButton: FC<ListProps & { option: SelectListOption }> = ({
  onChange,
  option: { value, label, disabled },
  selection,
}) => {
  const { panelcontainerNoneNone, bodytextDefaultNone } = useTheme();

  const styles = useStyles();

  const handleClick: (e: string) => void = (e) => {
    onChange?.(e);
  };

  return (
    <SelectItem
      className={styles.selectListOption}
      customStyle={{
        ...panelcontainerNoneNone,
        padding: "0.875rem 1rem",
        flexGrow: "1",
        textAlign: "start",
        fontWeight: "inherit",
        margin: 0,
        ...bodytextDefaultNone,
      }}
      key={value}
      onClick={() => handleClick(value)}
      selected={selection === value}
      disabled={disabled}>
      <StyledMarkup content={label} />
    </SelectItem>
  );
};

const SelectList: FC<ListProps & { options: SelectListOption[] }> = ({
  options,
  onChange,
  selection,
}) => {
  const styles = useStyles();
  return (
    <div className={styles.selectList}>
      {options.map((option) => (
        <SelectListButton
          {...{ option, onChange, selection }}
          key={option.value}
        />
      ))}
    </div>
  );
};

export default withThemeProvider(SelectList, {
  themeTokens: ["panelcontainerNoneNone", "bodytextDefaultNone"],
});
